<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cdit" clearable @clear="queryGroupList"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="success" icon="el-icon-search" @click="queryGroupList">搜索</el-button>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" icon="el-icon-plus" @click="addAdmin">新增</el-button>
        </el-col>
        <el-col :span="6">
          <el-radio-group v-model="queryInfo.status" @change="queryGroupList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="0">删除</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="部门分组" prop="title" width="150"></el-table-column>
        <el-table-column label="权限">
          <template slot-scope="scope">
            <span v-for="(item,ix) in scope.row.rules" :key="ix" style="margin-right:10px;" :style="{'color':ix%2?'#909399':''}">
              {{item.title}} {{item.name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status == '正常'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="medium" type="warning" :disabled="scope.row.status == '删除' ? true :false" @click="showEditDialog(scope.row)">修改</el-button>
              <el-button size="medium" type="success" v-if="scope.row.status == '删除'" @click="statusGroupById(scope.row.id,1)">恢复</el-button>
              <el-button size="medium" type="danger" v-else @click="statusGroupById(scope.row.id,0)">删除</el-button>
            </el-button-group>
            <el-button-group style="margin-left:10px;">
              <el-button size="medium" @click="groupRules(scope.row.id,scope.row.rules)">权限</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_ix" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <el-form :model="groupForm" :rules="groupFormRules" ref="groupForm" label-width="100px">
        <el-form-item label="标题名称" prop="title">
          <el-input v-model="groupForm.title"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('groupForm')">保存设置</el-button>
      </span>
    </el-dialog>

    <el-dialog title="管理权限" :visible.sync="rulesDialogVisible" width="50%">
      <el-form ref="groupForm1" label-width="100px">
        <el-checkbox-group v-model="rules_id_checked">
          <el-checkbox v-for="item in rules" :key="item.id" :label="item.id">{{item.title}}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('groupForm1')">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: '',
      formTitle: '',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        status: 1,
        cdit: '',
        page_ix: 1,
        page_size: 10
      },
      tableData: [],
      total: 0, // 分页总数
      // 控制添加用户对话框的显示与隐藏
      dialogFormVisible: false,
      // 用户的表单数据
      groupForm: {
        id: 0,
        title: ''
      },
      // 添加表单的验证规则对象
      groupFormRules: {
        title: [
          { required: true, message: '请输入部门分组', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '用户名的长度在1~20个字符之间',
            trigger: 'blur'
          }
        ]
      },
      rulesDialogVisible: false,
      rules_group_id: 0,
      rules: [],
      rules_id_checked: []
    }
  },
  created() {
    this.getRuleList()
    this.queryGroupList()
  },
  methods: {
    async getRuleList() {
      this.$axios.post('/admin/Auth/getRules', {}).then(res => {
        if (res.data.rst == 0) {
          this.rules = res.data.data
        }
      })
    },
    async queryGroupList() {
      this.$axios.post('/admin/Auth/queryGroup', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            e.status = !e.status ? '删除' : '正常'
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.page_size = newSize
      this.queryGroupList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page_ix = newPage
      this.queryGroupList()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.groupForm.resetFields()
    },
    addAdmin() {
      this.formTitle = '新增部门分组'
      this.add_edit = 'add'
      this.dialogFormVisible = true
      this.groupForm = {}
    },
    groupRules(group_id, rules) {
      this.rules_group_id = group_id
      this.rulesDialogVisible = true
      this.rules_id_checked = rules.map(item => {
        return item.id
      })
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      this.formTitle = '修改部门分组'
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      Object.assign(this.groupForm, row)
    },
    // 提交表单
    submitForm(formName) {
      if (formName == 'groupForm') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.add_edit == 'edit' || this.add_edit == 'add') {
              let editparams = {
                title: this.groupForm.title
              }
              if (this.add_edit == 'edit') {
                editparams['group_id'] = this.groupForm.id
              }
              this.$axios.post('/admin/Auth/saveGroup', editparams).then(res => {
                if (res.data.rst == 0) {
                  this.alertSuccess(res.data.msg)
                  this.queryGroupList()
                  this.dialogFormVisible = false
                } else {
                  this.alertError(res.data.msg)
                }
              })
            }
          }
        })
      } else if (formName == 'groupForm1') {
        let editparams = {
          group_id: this.rules_group_id,
          rules_id: JSON.stringify(this.rules_id_checked)
        }
        this.$axios.post('/admin/Auth/saveGroup', editparams).then(res => {
          if (res.data.rst == 0) {
            this.alertSuccess(res.data.msg)
            this.queryGroupList()
            this.rulesDialogVisible = false
          } else {
            this.alertError(res.data.msg)
          }
        })
      } else;
    },
    async statusGroupById(id, status) {
      const confirmResult = await this.$confirm(
        '此操作将' + (status == 1 ? '恢复' : '删除') + '该部门分组, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let editparams = {
        group_id: id,
        status: status
      }
      this.$axios.post('/admin/Auth/saveGroup', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.queryGroupList()
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .tip {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    clo
